import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-root gradient bgi-size-contain bgi-size-lg-auto bgi-no-repeat bgi-position-center" }
const _hoisted_2 = { class: "bg-gray-100 py-3" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center flex-equal\"><button class=\"btn btn-icon btn-active-color-primary me-3 d-flex d-lg-none\" id=\"kt_landing_menu_toggle\"><i class=\"ki-duotone ki-abstract-14 fs-2hx\"><span class=\"path1\"></span><span class=\"path2\"></span></i></button><a href=\"/\"><img alt=\"Logo\" src=\"/media/logos/hc.svg\" class=\"h-35px logo\"></a></div><div class=\"d-lg-block\" id=\"kt_header_nav_wrapper\"><div class=\"d-lg-block p-1 p-lg-0\"><div class=\"menu menu-column flex-nowrap menu-rounded menu-lg-row menu-title-gray-600 menu-state-title-primary nav nav-flush fs-5 fw-semibold\"></div></div></div>", 2)
const _hoisted_7 = { class: "d-flex align-items-center text-end me-1" }
const _hoisted_8 = {
  class: "d-flex align-items-center me-3 ms-lg-3",
  id: "kt_header_notifications_toggle"
}
const _hoisted_9 = { class: "btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px p-lg-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-active-color-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-translate fs-2" })
], -1)
const _hoisted_11 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-3",
  "data-kt-menu": "true",
  style: {}
}
const _hoisted_12 = { class: "menu-item px-3 border-bottom" }
const _hoisted_13 = { class: "menu-content text-muted pb-2 px-3 fs-7 text-uppercase" }
const _hoisted_14 = { class: "text-primary" }
const _hoisted_15 = { class: "menu-item px-3 mt-1" }
const _hoisted_16 = { class: "menu-item px-3" }
const _hoisted_17 = { class: "menu-item px-3" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Login ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Dashboard ")
const _hoisted_20 = {
  class: "container",
  style: {"min-height":"90vh"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTLoader = _resolveComponent("KTLoader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_KTFooter = _resolveComponent("KTFooter")!
  const _component_KTScrollTop = _resolveComponent("KTScrollTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loaderEnabled)
      ? (_openBlock(), _createBlock(_component_KTLoader, {
          key: 0,
          logo: _ctx.loaderLogo
        }, null, 8, ["logo"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.language.language`)) + ": ", 1),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.language.lang`)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("a", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLanguage('en'))),
                        class: "menu-link px-3"
                      }, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.language.en`)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("a", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('pt'))),
                        class: "menu-link px-3"
                      }, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.language.pt`)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("a", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLanguage('es'))),
                        class: "menu-link px-3"
                      }, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.language.es`)), 1)
                    ])
                  ])
                ])
              ]),
              (!_ctx.userAuth)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {name: 'sign-in'},
                    class: "btn btn-hc"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: {name: 'course-catalog'},
                    class: "btn btn-hc"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  }))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_router_view)
      ]),
      _createVNode(_component_KTFooter)
    ]),
    _createVNode(_component_KTScrollTop)
  ], 64))
}